import React, { useContext } from "react";
import "./style.css";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BrokenStar from "../GlobalIcons/BrokenStar";
import { filterDataContext } from "../../App";

const FilterChip = ({
  name,
  id,
  searchParams,
  setSearchParams,
  removeKey,
  setSortingTabFromChips,
}) => {
  const { setTicketAvailabiltyInput, setMaxPriceInput, setMinPriceInput } =
    useContext(filterDataContext);

  const RemoveParam = (Key) => {
    searchParams.delete("page");
    if (Key === "date") {
      searchParams.delete("date_start");
      searchParams.delete("date_stop");
    } else if (Key === "price") {
      searchParams.delete("minPrice");
      setMinPriceInput("");
      searchParams.delete("maxPrice");
      setMaxPriceInput("");
    } else if (Key === "ticket_Availability") {
      searchParams.delete("ticket_Availability");
      setTicketAvailabiltyInput("");
    } else {
      searchParams.delete(Key);
    }
    setSearchParams(searchParams);
  };

  return (
    <div className="chips_sec chips_for_upper">
      <div
        className="content_search"
        onClick={() => {
          setSortingTabFromChips && setSortingTabFromChips(removeKey);
        }}
      >
        <div className="icon_search_cat">
          <BrokenStar />
        </div>
        <div className="content_head">
          <h5>{name}</h5>
        </div>
      </div>
      <span
        className="cross_icon"
        onClick={() => {
          RemoveParam(removeKey);
        }}
      >
        <FontAwesomeIcon icon={faClose} />
      </span>
    </div>
  );
};

export default FilterChip;
